import React from 'react';
import PropTypes from 'prop-types';

const Item = ({ value, text }) => (
  <option value={value}>{text}</option>
);

const SelectInput = props => (
  <select
    name={`${props.groupName}[${props.name}]`}
    className={props.className}
    value={props.selected}
    onChange={props.onChange}
    disabled={props.disabled} >
    {props.options.map(item => <Item key={item.value} {...item} />)}
  </select>
);

SelectInput.defaultProps = {
  name     : '',
  groupName: 'parameters',
  className: 'form-select',
  options  : [],
};

SelectInput.propTypes = {
  name     : PropTypes.string,
  groupName: PropTypes.string,
  className: PropTypes.string,
  options  : PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    text : PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  })),
}

export default SelectInput;
